import { render, staticRenderFns } from "./GlassesLensList.vue?vue&type=template&id=55b25be8&scoped=true&"
import script from "./GlassesLensList.vue?vue&type=script&lang=js&"
export * from "./GlassesLensList.vue?vue&type=script&lang=js&"
import style0 from "./GlassesLensList.vue?vue&type=style&index=0&id=55b25be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b25be8",
  null
  
)

export default component.exports